import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem, Multiselect } from '../../../core/interfaces/admin.interface';
import { PortalService } from '../../../core/services/portal.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-product-family-select',
  templateUrl: './product-family-select.component.html',
  styleUrls: ['./product-family-select.component.scss']
})
export class ProductFamilySelectComponent {

  @Input() set preselectedFamilies(newValue: number[]) {
    this.selectFromId(newValue);
  }

  @Input() disabled: boolean = false;

  @Input() familiesSelected: MultiselectItem[] = [];

  @Output() familiesSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  list: MultiselectItem[] = [];

  preselectedIds: number[];

  constructor(
    public portalService: PortalService,
  ) {

    this.load();

  }

  onElementSelect(): void {
    this.familiesSelectedChange.emit(this.familiesSelected);
    this.onSelected.emit(this.familiesSelected);
  }

  load() {

    this.portalService.getMultiselectItems(Multiselect.PRODUCT_FAMILY).subscribe((response) => {

      this.list = response?.data.map(family => {

        return {
          id: family.id,
          itemName: family.name
        } as MultiselectItem

      })

      if (this.preselectedIds?.length && this.familiesSelected.length == 0) {
        this.selectFromId(this.preselectedIds);
      }

    },
    (error) => {
      console.log("errore", error);
    });

  }

  selectFromId(ids: number[], withEvent: boolean = true) {

    this.preselectedIds = ids;

    this.familiesSelected = this.list.filter(c => ids?.includes(c.id));
    if (withEvent) {
      this.onElementSelect();
    }

  }

}
